// CTSK-267 — Future Windows tab table (future-events.yaml). The file
// shares the `timeline-marker-v1` schema with markers.yaml, so the
// rendering IS TimelineMarkersTable — this wrapper only selects the
// schema-appropriate filter set for planning windows (track — open
// vocab from the data — and timing: upcoming / active / past relative
// to now) instead of the Markers tab's scope + kind dropdowns, and
// switches the copy to "future windows". Matches the one-component-
// per-tab pattern of the other timeline tables so TimelineLane's
// dispatch stays flat.

import { TimelineMarkersTable } from './TimelineMarkersTable.js';

export function FutureWindowsTable({ yamlText }: { yamlText: string }) {
  return <TimelineMarkersTable yamlText={yamlText} variant="future" />;
}
